import {
  clearStoredWorkspaceOrigin,
  getStoredOfficeHref,
  officeAuthStartUrlErrorMessage,
  OfficeAuthStartUrlError,
  validateWorkspaceBySetupRequest,
} from '@/utils';
import { notify } from '@/components/AppNotification';
import { t } from '@/plugins/i18n.plugin';
import { SIGNED_OUT_QUERY_PARAM } from '@/common/constants';
import type { RouteLocationNormalized } from 'vue-router';

export async function landingBeforeEnter(
  to: RouteLocationNormalized
): Promise<boolean> {
  // The office app signed out: forget the workspace so the user can pick another one.
  if (to.query[SIGNED_OUT_QUERY_PARAM]) {
    clearStoredWorkspaceOrigin();
    return true;
  }

  const officeHref = getStoredOfficeHref();
  if (!officeHref) {
    return true;
  }

  const origin = new URL(officeHref).origin;
  const { ok, error } = await validateWorkspaceBySetupRequest(origin, origin);

  if (!ok) {
    if (error === OfficeAuthStartUrlError.SetupResponseInvalid) {
      clearStoredWorkspaceOrigin();
    }
    notify(officeAuthStartUrlErrorMessage(error!), { type: 'error' });
    return true;
  }

  try {
    window.location.replace(officeHref);
    return false;
  } catch {
    notify(t('COULD_NOT_REDIRECT_TO_THE_WORKSPACE_PLEASE_TRY_AGAIN'), {
      type: 'error',
    });
    return true;
  }
}
